import React, { useState } from "react";
import { Menu, Layout } from 'antd';
import * as Icon from "react-feather";
import { useLocation, Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

const { Sider } = Layout;
const { SubMenu } = Menu;

// const Navbar = () => {
const rootSubmenuKeys = ["sub1", "sub2", "sub3", "sub4"];

const Navbar = ({ collapsed }) => {

  const location = useLocation();
  const { pathname } = location;

  const [openKeys, setOpenKeys] = useState(['sub1']);

  const userInfo = useSelector(state => state.authenReducer.userInfo);

  const onOpenChange = keys => {
    const latestOpenKey = keys.find(key => openKeys.indexOf(key) === -1);
    if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      setOpenKeys(keys);
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    }
  };

  return (
    <Sider trigger={null} collapsible collapsed={collapsed} width="250">
      <div className="logo-nmn-horizontal border-bottom">
        <img src="../assets/logo_nmn-horizontal.png" style={{ with: 200 }} alt="logo-nmn" />
      </div>
      <Menu theme="dark" openKeys={openKeys} onOpenChange={onOpenChange} selectedKeys={[pathname]} mode="inline" className="my-3">
        {userInfo.userRole !== 'ADMIN' ? 
          <SubMenu key="sub1" title="Content Management" icon={<Icon.FileText size={18} />}>
            <Menu.Item key="/banner" className="mb-0 mt-0" ><Icon.Circle className="me-2 transform-nmu" size={7} /><Link to="/banner">Banner</Link></Menu.Item>
            <Menu.Item key="/highlight-box" className="mb-0 mt-0"><Icon.Circle className="me-2 transform-nmu" size={7} /><Link to="/highlight-box">Highlight Box</Link></Menu.Item>
            <Menu.Item key="/main-content" className="mb-0 mt-0"><Icon.Circle className="me-2 transform-nmu" size={7} /><Link to="/main-content">Main content</Link></Menu.Item>
            <Menu.Item key="/news" className="mb-0 mt-0"><Icon.Circle className="me-2 transform-nmu" size={7} /><Link to="/news">News</Link></Menu.Item>
            <Menu.Item key="/service-link" className="mb-0 mt-0"><Icon.Circle className="me-2 transform-nmu" size={7} /><Link to="/service-link">Service Link</Link></Menu.Item>
            <Menu.Item key="/footer-link" className="mb-0 mt-0"><Icon.Circle className="me-2 transform-nmu" size={7} /><Link to="/footer-link">Footer Link</Link></Menu.Item>
            <Menu.Item key="/menu" className="mb-0 mt-0"><Icon.Circle className="me-2 transform-nmu" size={7} /><Link to="/menu">Menu</Link></Menu.Item>
            <Menu.Item key="/template-content" className="mb-0 mt-0"><Icon.Circle className="me-2 transform-nmu" size={7} /><Link to="/template-content">Content</Link></Menu.Item>
            <Menu.Item key="/notification" className="mb-0 mt-0"><Icon.Circle className="me-2 transform-nmu" size={7} /><Link to="/notification">Notification</Link></Menu.Item>
            <Menu.Item key="/activity" className="mb-0 mt-0"><Icon.Circle className="me-2 transform-nmu" size={7} /><Link to="/activity">Calendar Activity</Link></Menu.Item>
          </SubMenu>
          : null}
        
        <SubMenu key="sub2" title="Gallery Management" icon={<Icon.Image size={18} />}>
          <Menu.Item key="/gallery/photo" className="mb-0 mt-0"><Icon.Circle className="me-2 transform-nmu" size={7} /><Link to="/gallery/photo">Photo</Link></Menu.Item>
          <Menu.Item key="/gallery/video" className="mb-0 mt-0"><Icon.Circle className="me-2 transform-nmu" size={7} /><Link to="/gallery/video">Video</Link></Menu.Item>
          <Menu.Item key="/gallery/document" className="mb-0 mt-0"><Icon.Circle className="me-2 transform-nmu" size={7} /><Link to="/gallery/document">Document</Link></Menu.Item>
        </SubMenu>

        {userInfo.userRole !== 'CM' ? 
          <SubMenu key="sub3" title="Chat Management" icon={<Icon.MessageSquare size={18} />}>
            <Menu.Item key="/live-chat" className="mb-0 mt-0"><Icon.Circle className="me-2 transform-nmu" size={7} /><Link to="/live-chat">Chat</Link></Menu.Item>
          </SubMenu>
          : null}
          
        {userInfo.userRole !== 'CM' ? 
          <SubMenu key="sub4" title="Admin Management" icon={<Icon.Users size={18} />}>
            <Menu.Item key="/user-management" className="mb-0 mt-0"><Icon.Circle className="me-2 transform-nmu" size={7} /><Link to="/user-management">Manage User</Link></Menu.Item>
          </SubMenu>
          : null}

      </Menu>
    </Sider>
  );
};

export default Navbar;
